import { DesignationsTabState } from './state';


export const initialDesignationTabState: DesignationsTabState = {
  loading: false,
  loaded: false,
  error: undefined
};

export function designationsTabReducer(
  state: DesignationsTabState = initialDesignationTabState,
  _action
): DesignationsTabState {

  return state;
}